import React from 'react';
import './RetroToggle.css';
import useLongPressTooltip from './useLongPressTooltip';

const RetroToggle = ({ enabled, onToggle }) => {
  const label = enabled ? 'Switch to modern UI' : 'Go retro';
  const { isVisible, buttonProps } = useLongPressTooltip(onToggle);

  return (
    <div className="retro-toggle-wrap">
      <button
        type="button"
        className="retro-toggle"
        {...buttonProps}
        aria-pressed={enabled}
        aria-label={label}
        aria-describedby="retro-toggle-tooltip"
      >
        {enabled ? (
          <svg className="retro-toggle__modern-icon" viewBox="0 0 24 24" aria-hidden="true">
            <rect x="3" y="4" width="18" height="16" rx="3" />
            <path d="M3 9h18M7 6.5h.01M10 6.5h.01M7 13h4v3H7zM14 13h3M14 16h3" />
          </svg>
        ) : (
          <svg className="retro-toggle__crt-icon" viewBox="0 0 24 24" aria-hidden="true">
            <rect x="3" y="4" width="18" height="13" rx="1" />
            <path d="M7 21h10M9 17v4M15 17v4M6.5 8h4M6.5 11h7" />
          </svg>
        )}
      </button>
      <span
        id="retro-toggle-tooltip"
        className={`retro-toggle__tooltip${isVisible ? ' is-touch-visible' : ''}`}
        role="tooltip"
      >
        {label}
      </span>
    </div>
  );
};

export default RetroToggle;
